import {Card, Space} from "antd";
import {CDNURL} from "../config";

export const Attachments = (props) => {
    let attachments = [...(props.attachments || [])]
    if (props.description) {
        attachments = [...(props.attachments || [])].filter(a => a.description === props.description)
    }
    if (attachments.length === 0) return <></>
    return (<>
        <div style={{padding: '10px'}}></div>
        <Space direction="vertical" size="small" style={{display: 'flex'}}>
            {attachments.map(attachment =>
                <Card
                    size="small"
                    title={attachment.text}
                    extra={<a target="_blank" href={CDNURL + attachment.path}>打开</a>}
                >
                    {attachment.name}
                    <p>{new Date(attachment.created_at).toLocaleString()}</p>
                </Card>)}
        </Space>
    </>)
}
